var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPj7Expiration = function SvgPj7Expiration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pj7Expiration_svg__a)",
    stroke: "current",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.667 5.5v7.333a1.833 1.833 0 0 0 1.833 1.834h7.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.167 38.5H12.833a3.667 3.667 0 0 1-3.666-3.667V9.167A3.667 3.667 0 0 1 12.833 5.5h12.834l9.166 9.167v20.166a3.667 3.667 0 0 1-3.666 3.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 33a7.333 7.333 0 1 0 0-14.667A7.333 7.333 0 0 0 22 33Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Pj7Expiration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};

export default SvgPj7Expiration;